<template>
	<div class="issue-warp">
		<div class="electronic_content pzly">
                <div class="item" v-for="(item, index) in pzlyList" :key="index">
                    <img :src="imgAllPath(item.img)" alt />
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.content }}</p>
                </div>
            </div>
		<section :class="{ created: hasCreated }">
			<div class="cont-box sel-box" v-if="!hasCreated">
				<el-row :gutter="10" class="title-box">
					<el-col>
						<div class="title">
							<i class="sort-box">01</i>
							<p>电子凭证数据导入</p>
						</div>
					</el-col>
				</el-row>
				<div class="contant-box">
					<el-row :gutter="10" class="upload-box">
						<el-col :span="7">
							<el-input class="readonly-inp" type="primary" size="small" readonly
								v-model="sampleFile.name" />
						</el-col>
						<el-col :span="3">
							<el-button type="primary" size="small" style="margin-left:20px" :disabled="loading" @click="sampleDialog = true">
								选择示例文件</el-button>
						</el-col>
						<el-col :span="4">
							<el-button type="primary" size="small" class="w68" @click="uploadBtn" v-if="!token">上传文件</el-button>
							<el-upload class="upload-demo" v-else ref="upload" accept=".xml" action="#" :show-file-list="false"
								:on-change="handleChange" :before-upload="beforeUpload" :http-request="handleUploadFile"
								:disabled="loading">
								<el-button type="primary" size="small" class="w68" :loading="loading2" :disabled="loading">上传文件</el-button>
							</el-upload>
						</el-col>
					</el-row>
				</div>
				<el-row :gutter="10" class="title-box">
					<el-col>
						<div class="title">
							<i class="sort-box">02</i>
							<p>电子凭证模板选择</p>
						</div>
					</el-col>
				</el-row>
				<div class="contant-box temp-box">
					<ul class="hover-ul">
						<li v-for="(item, index) in tempList" :key="index" @click="handleChooseTemp(item)">
							<div class="cont" :class="{ nocont: loading, actont: chooseTempId === item.id }">
								<img class="icon"
									:src="chooseTempId !== item.id ? require('@comm/images/document-conversion/electronic/checkbox.png') : require('@comm/images/document-conversion/electronic/checked.png')" />
								<div class="pic" style="width:90%;height: 100%;"><img :src="item.src" /></div>
								<div class="hover-box">
									<el-button size="small" class="temp-btn" @click="handleJumpToEdit(index + 1)">更新模板</el-button>
								</div>
							</div>
							<p class="name">{{ item.name }}</p>
						</li>
						<li class="add-new">
							<div class="cont" :class="{ nocont: loading }">
								<div @click="handleJumpToEdit(0)">
									<img :src="require('@comm/images/document-conversion/electronic/add.png')" />
									<p class="img-text">新建模板</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

			<div class="cont-box res-box" v-else>
				<ul class="result-box">
					<li><img :src="createdInfo.imagePath" /></li>
					<li><a :title="createdInfo.fileName || sampleFile.name">{{ createdInfo.fileName || sampleFile.name | limitFileName(20) }}</a></li>
					<li>
						<el-button type="primary" class="cont-btn" @click="handleToPreview">在线预览</el-button>
						<el-button type="primary" class="cont-btn" @click="handleDownload('ofd')">凭证下载</el-button>
						<el-button class="cont-btn-no" @click="handleDownload('pdf')">下载为PDF
						</el-button>
					</li>
				</ul>
			</div>
			<el-divider />
			<footer class="title-box">
				<el-button type="primary" :disabled="!isCreateBtn" @click="handleCreate" v-if="!loading">
					<span>{{ hasCreated ? "生成完成" : loading ? "生成凭证中" : "生成凭证" }}</span>
				</el-button>
				<el-button type="primary" :disabled="loading" @click="handleCreate" v-else> <i
						class="downing_icon" /><span>生成凭证中</span> </el-button>
			</footer>
		</section>
		<ContantHead :title="['上传数据文件', '选择模板', '生成凭证', '凭证下载(OFD/PDF)']" />
		<SampleDialog title="选择示例文件" :show.sync="sampleDialog" @confirm="handleConfirmSel" />
	</div>
</template>

<script>
import ContantHead from "./components/ContantHead";
import SampleDialog from "./components/SampleDialog";
import { issueUploadFile, compoundByTemplate, downloadOFD, downloadPDF } from "@comm/api/document-conversion/issue";
import { exportBlobData } from "@comm/utils/tools";
import common from "@comm/utils/common";
export default {
	name: "VoucherIssue",
	components: { ContantHead, SampleDialog },
	props: {
		token: { type: String, default: "" }
	},
	data() {
		const tmepData = () => {
			const arr = ["电子发票", "电子回单", "电子对账单", "电子客票（高铁）", "航空行程单", "非税票据", "会计凭证"];
			return arr.map((item, index) => ({ id: index + 1, name: item, src: require(`@comm/images/document-conversion/electronic/${item}.png`) }));
		};
		return {
			loading: false,
			loading2: false,
			// 选择示例文件
			sampleFile: {},
			// 选中示例id
			chooseTempId: null,
			// 示例弹窗
			sampleDialog: false,
			// 模板列表
			tempList: tmepData(),
			// 是否生成凭证
			hasCreated: false,
			// 上传之后获取的file id
			uploadFileId: "",
			// 生成结果
			createdInfo: {},
			pzlyList: [
                { img: 'pzly_01.png', name: '模板设计与管理', content: '提供标准化模板库。支持可视化在线模板设计，通过丰富的属性设置，生成各种定义模板' },
                { img: 'pzly_02.png', name: '印章管理', content: '支持直接上传印章，在线配置生成印章，统一管理印章及证书。支持查看印章及证书详情' },
                { img: 'pzly_03.png', name: '发布管理', content: '支持将定稿模板及印章进行业务发布，与业务系统数据做相应关联。支持对已发布项进行查看与管理' },
                { img: 'pzly_04.png', name: '生成凭证', content: '高效的数据合成服务引擎，可快速生成OFD凭证，通过不同的合成策略，满足各种大数据合成场景' },
                { img: 'pzly_05.png', name: '可视化服务监控', content: '提供可视化服务监控及在线配置，通过界面方便快速地进行服务参数配置，并实时关注服务及进程的运行情况' }
            ],
			isUpload:false
		};
	},
	computed: {
		isCreateBtn() {
			return (this.chooseTempId && this.chooseTempId.toString().length && Object.keys(this.sampleFile).length) || this.loading;
		},
		imgAllPath() {
            return function (img) {
                return require(`@comm/images/document-conversion/electronicDocuments/${img}`);
            };
        },
	},
	methods: {
		handleJumpToEdit(index) {
			if (this.loading) return;
			if (index) {
				const encodeURL = encodeURIComponent(common.staticPIC + index);
				window.open(`/static/form-designer/index.html?templateUrl=${encodeURL}`, "_blank");
			} else {
				window.open('/static/form-designer/index.html', "_blank");
			}
		},
		handleConfirmSel(item) {
			this.sampleFile = { ...item, name: item.name + ".xml" };
			this.chooseTempId = item ? item.id : "";
			this.uploadFileId = item ? item.id : "";
			this.sampleDialog = false;
		},
		handleChange(file, fileList) { },
		uploadBtn() {
			if (!this.token) {
				let path = this.$route.path;
				window.open(
					`https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
					"_self"
				);
				return
			}
		},
		beforeUpload(file) {
			this.sampleFile = {};
			const reg = /^text\/(\w|-)*xml$/gi;
			if (!reg.test(file.type)) {
				this.$message.error("文件格式错误");
				return false;
			}
		},
		// 上传文件
		handleUploadFile(params) {
			const { file } = params;
			if (file.size === 0) {
				this.$confirm("上传文件大小不能为空!", "", {
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "error",
					customClass: "custom-notitle-confirm"
				});
				return;
			}
			const isLt5M = file.size / 1024 / 1024 < 5;
			if (!isLt5M) {
				this.$confirm("您选择的文件总大小超过5M，请重新选择！", "", {
					cancelButtonText: "取消",
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "warning",
					showClose: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					lockScroll: false
				}).then(() => {
					return;
				});
				return;
			}

			this.loading2 = true;
			const formData = new FormData();
			formData.append("multipartFile", file);
			issueUploadFile(formData)
				.then((res) => {
					this.sampleFile = file;
					this.uploadFileId = res.data;
					this.isUpload=true
				})
				.catch(()=>{
					this.isUpload=false
				})
				.finally(() => {
					this.loading2 = false;
				});
		},
		// 确认生成
		handleCreate() {
			if (this.loading) return;
			if (this.hasCreated) {
				this.$confirm("生成完成将清空当前文档，请您先下载保存文档，是否继续生成？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					cancelButtonClass: "fr",
					callback: (action) => {
						if (action === "confirm") {
							this.hasCreated = false;
							this.resetFileInfo();
						}
					}
				});
			} else {
				const { uploadFileId, chooseTempId } = this;
				const params = {
					fileId: uploadFileId,
					templateName: chooseTempId
				};
				this.loading = true;
				compoundByTemplate(params,this.isUpload)
					.then((res) => {
						const { code, msg } = res;
						if (code === "A0005" || code === "A0007") {
							this.$alert(msg, "提示", {
								confirmButtonText: "确定",
								callback: () => { }
							});
						} else {
							this.createdInfo = res.data;
							this.createdInfo.isUpload=this.isUpload
							this.hasCreated = true;
							this.$store.commit("SET_UPLOADISSUEDATA", this.createdInfo);
						}
					})
					.finally(() => (this.loading = false));
			}
		},
		// 重置文件信息
		resetFileInfo() {
			this.chooseTempId = null;
			this.uploadFileId = "";
			this.createdInfo = {};
			this.sampleFile = {};
		},
		handleToPreview() {
			this.$store.commit("SET_ACTIVEMODEL", "2");
			this.$store.commit("SET_UPLOADSOURCE", true);
		},
		// 生成凭证后下载
		handleDownload(type) {
			const { fileId } = this.createdInfo;
			if (type === "ofd") {
				downloadOFD({ fileId },this.isUpload).then((res) => {
					exportBlobData(res);
				});
			} else if (type === "pdf") {
				downloadPDF({ fileId },this.isUpload).then((res) => {
					exportBlobData(res);
				});
			}
		},
		handleChooseTemp(item) {
			if (this.loading) return;
			this.chooseTempId = this.chooseTempId === item.id ? null : item.id;
		}
	}
};
</script>

<style lang="scss" scoped>
.issue-warp {
	width: 1200px;
	// height: 90px;
	// box-sizing: border-box;
	.pzly{
		margin: 49px 0 64px;
	}
	.cont-btn{
		background: none!important;
		color: #14a8f0!important;
		border-color: #14a8f0!important;
		margin-left: 8px!important;
		width: 104px!important;
		&:hover{
			color: #fff!important;
			background: #14a8f0!important;
		}
	}
	.cont-btn-no{
		margin-left: 24px!important;
	}
	section {
		width: 100%;
		height: 768px;
		border: 1px solid #d0d0d0;
		padding: 32px 0 24px;
		display: flex;
		flex-direction: column;

		.cont-box {
			flex: 1;
			width: 100%;
			overflow: hidden;
		}

		.title {
			display: flex;
			align-items: center;
			color: #36425a;
			font-size: 16px;
		}

		.sort-box {
			display: block;
			width: 30px;
			height: 30px;
			background: #14a8f0;
			border-radius: 50%;
			color: #fff;
			text-align: center;
			line-height: 30px;
			font-style: normal;
			margin-right: 20px;
		}

		.title-box {
			padding: 0 32px;

			button {
				position: relative;
			}
		}

		.contant-box {
			padding: 16px 86px 36px;
		}

		.upload-box {
			margin: 0;
		}

		footer {
			text-align: right;
		}

		.temp-box {
			flex: 1;
			overflow: auto;
			padding: 36px 67px 22px;
		}

		.result-box {
			width: 100%;
			height: 100%;
			background-color: #fff;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			li {
				width: auto;
				overflow: hidden;
			}

			&>li:nth-child(1) {
				width: 600px;
				height: 400px;
				padding: 27px;
				border: 1px solid #d8d8d8;
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: auto;
					height: auto;
					max-width: 100%;
					max-height: 100%;
				}
			}

			&>li:nth-child(2) {
				margin: 24px 0 32px 0;
				color: #242f44;
				font-size: 16px;
			}
		}
	}

}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/electronicDec/Issue.vue